import gql from 'graphql-tag'
import marketplaceCheckoutParcelFragment from '../fragments/marketplace-checkout-parcel'
import { IMarketplaceParcel } from '../../types/marketplace-checkout'

export default gql`
  mutation updateMarketplaceCheckoutParcelFulfilment(
    $input: UpdateMarketplaceCheckoutParcelFulfilmentInput!
  ) {
    parcel: updateMarketplaceCheckoutParcelFulfilment(input: $input) {
      ...marketplaceCheckoutParcel
    }
  }
  ${marketplaceCheckoutParcelFragment}
`

export interface IUpdateMarketplaceCheckoutParcelFulfilmentData {
  parcel?: IMarketplaceParcel | null
}

export interface IUpdateMarketplaceCheckoutParcelFulfilmentVariables {
  input: {
    parcelId: string
    selectedFulfilmentOptionId: string
  }
}
